import { Theme } from './../index.d';

const UI_THEME_DEFAULT: Theme = {
  pallete: {
    main: '#001030',
    'alternative-main': '#001847',
    'main-light': '#334066',
    'main-alternative-light': '#4d5a80',
    'main-lighter': '#99a3bf',
    'main-alternative-lighter': '#e6e9f2',
    'new-ligther': '#f5f5f5',
    'new-gray': '#4a4a4a',
    'main-new-light': '#fbf9f3',

    black: '#242424',
    'new-black': '#161616',
    'alternative-dark': '#191919',
    'input-black': '#4c4c4c',
    'alternative-black': '#3b3b3b',
    'light-gray': '#fff8f5',
    secondary: '#C4AB74',
    'alternative-secondary': '#BFA462',
    'alternative-secondary-light': '#D1BA82',
    'secondary-light': '#E4D5AE',
    'secondary-lighter': '#F2EAD2',
    'yellow-light': '#FFF3C2',
    dark: '#666666',
    'dark-light': '#7f7f7f',
    gray: '#a4a3a3',
    'alternative-gray': '#929292',
    'gray-light': '#a6a6a6',
    'gray-dark': '#484747',
    light: '#808080',

    green: '#00b329',
    'light-purple': '#f4f2f9',
    'light-purple-opacity': '#1971BA',

    'secondary-font': "'Proxima Nova', serif",
    'main-font': "'Open Sans', sans-serif",

    'font-xxs': '10px',
    'font-xs': '12px',
    'font-sm': '14px',
    'font-md': '16px',
    'font-lg': '18px',
    'font-xl': '24px',
    'font-xxl': '32px',

    purple: '#651fff',
    'lighter-purple': '#e0d2ff',
    'lighter-alternative-purple': '#d5cce7',
    'alternative-dark-purple': '#6d4dae',
    'dark-purple': '#410cb3',
    'transparent-purple': 'rgba(151, 128, 197, 1)',

    orange: '#ff911f',
    'orange-light': '#ffbfa0',

    danger: '#e80606',
    'danger-dark': '#950000',
    'danger-light': '#ef5151',
    'danger-lighter': '#facdcd',

    lighter: '#e5e5e5',
    lightness: '#f8f8f8',
    'pagination-active-background': '#00163a',
    'transparent-gray': '#d6dcd97a',

    'main-dark': '#2680eb',
    'transparent-main-light': '#1191e23d',

    'secondary-dark': '#e8c61c',
    'transparent-secondary-dark': '#ffc73d52',

    white: '#ffffff',
    'transparent-black': '#00000014',
    'alternative-transparent-black': 'rgba(0, 0, 0, 0.4)',
    logo: 'url("/assets/banvox/logo.png")',
    'logo-horizontal': 'url("/assets/banvox/logo.png")',
    'login-background': 'url("/assets/images/login-background.svg")',
  },
  brand: {
    name: 'Banvox',
    company_name: 'Banvox Distribuidora de Títulos e Valores Mobiliários Ltda',
    company_cnpj: '02.671.743/0001-19',
    desc: 'Módulo de cadastro',
    prefix: 'banvox',
    footerText: `Banvox - Todos os direitos reservados ${new Date().getFullYear()}`,
    logoText: 'Banvox',
    logoWidth: 50,
    minWidth: 50,
    logo: '/assets/banvox/logo.png',
    logoHorizontal: '/assets/banvox/logo.png',
    favicon: '/assets/favicon/banvox-favicon.ico',
    simplifiedFund: false,
  },
  api: {
    // local: 'http://127.0.0.1:8000',
    // local: 'https://petite-garlics-unite.loca.lt',
    local: 'https://stage.api.data.banvox.prosperita.io',
    dev: 'https://dev.api.data.banvox.prosperita.io',
    stage: 'https://stage.api.data.banvox.prosperita.io',
    prod: 'https://api.data.banvox.prosperita.io',
    clarity_id: 'fhco559uuk',
    sentry_dsn:
      'https://561c977b8b3148de9e15e4e241b2e6ca@sentry.tools.prosperita.io/25',
  },
};

export default UI_THEME_DEFAULT;
